import { useEffect, useState } from 'react'

const useIsSsr = (): boolean => {
  const [isSSR, setIsSSR] = useState(true)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsSSR(false)
    }
  }, [])

  return isSSR
}

export default useIsSsr
